import { SystemActionLogsTypeEnum, useGetSystemActionCountQuery } from "gql/generated.graphql";
import DashboardWidgetContainer from "../DashboardWidgetContainer/DashboardWidgetContainer";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useCallback, useContext, useMemo } from "react";
import { DatePeriodTypesEnum, FilterContext, getPeriodRangeByPeriodType } from "dash-ui";


const DashboardWidgetPropertyAddedPortfolio = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');
  const { state: filterState } = useContext(FilterContext);
  const propertyId = filterState?.propertyId;

  const { data: dataPeriod, loading: loadingPeriod } =
    useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.PropertyAddedToPortfolio,
          dateRange: filterState.dateRange
          ? {
              startDate: filterState.dateRange?.startDate,
              endDate: filterState.dateRange?.endDate,
            }
          : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { countPeriod } = useMemo(
    () => ({
      countPeriod: dataPeriod?.getSystemActionCount || 0,
    }),
    [dataPeriod]
  );

  const { data, loading } =
  useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.PropertyAddedToPortfolio,
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { count } = useMemo(
    () => ({
      count: data?.getSystemActionCount || 0,
    }),
    [data]
  );

  const makePlaceholderText = useCallback(() => {
    if (count === 0) {
      return t('organizationDashboardPage.propertyAddedPortfolioPlaceholderText') || '';
    }
    return t('organizationDashboardPage.propertyAddedPortfolioPlaceholderTextPeriod') || '';
  }, [count, t])

  return (
    <DashboardWidgetContainer
      bgColor={theme.colors.b200}
      icon="house"
      placeholderTitle={
        t('organizationDashboardPage.addedToPortfoliosPlaceholderTitle') || ''
      }
      placeholderText={makePlaceholderText()}
      count={countPeriod}
      loading={loadingPeriod && loading}
    />
  )
}

export default DashboardWidgetPropertyAddedPortfolio;
